export default __webpack_public_path__ + "static/media/gear.d9d06ed9.svg";